import type { HealthResponse } from '../../api/types';

interface SystemSummaryProps {
  health: HealthResponse | null;
  loading: boolean;
  onNavigate: (hash: string) => void;
}

export function SystemSummary({ health, loading, onNavigate }: SystemSummaryProps) {
  if (loading) {
    return (
      <div class="system-summary">
        <div class="system-summary-item">
          <span class="skeleton" style={{ width: '8px', height: '8px', borderRadius: '50%' }} />
          <span class="skeleton skeleton-text" style={{ width: '80px', marginBottom: 0 }} />
        </div>
      </div>
    );
  }

  if (!health) {
    return (
      <div class="system-summary">
        <div
          class="system-summary-item"
          style={{ cursor: 'pointer' }}
          onClick={() => onNavigate('ops/health')}
        >
          <span class="system-summary-dot unknown" />
          <span class="system-summary-label">Health check unavailable</span>
        </div>
      </div>
    );
  }

  const deps = Object.entries(health.dependencies);

  return (
    <div class="system-summary">
      {deps.map(([name, status]) => (
        <div
          key={name}
          class="system-summary-item"
          style={{ cursor: 'pointer' }}
          onClick={() => onNavigate('ops/health')}
        >
          <span class={`system-summary-dot ${status === 'ok' ? 'ok' : 'error'}`} />
          <span class="system-summary-label">{name}</span>
          <span class="system-summary-value">{status}</span>
        </div>
      ))}
    </div>
  );
}
